var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M 0.5 0 C 0.223 0 0 0.223 0 0.5 C 0 0.777 0.223 1 0.5 1 C 0.777 1 1 0.777 1 0.5 C 1 0.223 0.777 0 0.5 0 Z M 0.125 0.5 C 0.125 0.293 0.293 0.125 0.5 0.125 C 0.707 0.125 0.875 0.293 0.875 0.5 C 0.875 0.707 0.707 0.875 0.5 0.875 C 0.293 0.875 0.125 0.707 0.125 0.5 Z M 0.25 0.5 C 0.25 0.465 0.277 0.438 0.313 0.438 L 0.688 0.438 C 0.723 0.438 0.75 0.465 0.75 0.5 C 0.75 0.535 0.723 0.563 0.688 0.563 L 0.313 0.563 C 0.277 0.563 0.25 0.535 0.25 0.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnd);
export default __webpack_public_path__ + "static/media/dnd.c73a099eccee4fcbb613efc630295bd7.svg";
export { ForwardRef as ReactComponent };